module.exports = __webpack_public_path__ + "static/media/MasaiFamily.00dc9e6b.jpg";